import React, { FunctionComponent, useMemo } from 'react';

import click from '@gojob/tracking/click';
import Cta from '@gojob/ui-bits/Cta';
import Flex, { FlexProps } from '@gojob/ui-bits/Flex';
import useIsHydrated from '@gojob/ui-bits/hooks/useIsHydrated';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import join from 'url-join';

import useSharedToken from 'src/components/SharedTokenProvider/useSharedToken';
import useTranslation from 'src/translations/useTranslation';

export type SignupPromotionProps = FlexProps<'div'>;

const SignupPromotion: FunctionComponent<SignupPromotionProps> = (props) => {
  const { spacing } = useTheme();
  const t = useTranslation();

  const isHydrated = useIsHydrated();

  const href = useMemo(() => join(process.env.FOG_URL || '', '/signup'), []);
  const handleOnClick = () => {
    click({
      eventCategory: 'jobboard',
      eventAction: 'subscribe-bottom-results-cta',
      eventName: 'subscribe',
    });
  };

  const token = useSharedToken();
  if (token || !isHydrated) {
    return null;
  }

  return (
    <Flex maxWidth={spacing(50)} flexDirection="column" alignItems="center" {...props}>
      <Text css={{ textAlign: 'center' }} as="h3" variant="headline4" gutter={6}>
        {t('signup_to_see_more_offers')}
      </Text>

      <Cta as="a" variant="cheery" href={href} onClick={handleOnClick}>
        {t('i_will_signup')}
      </Cta>
    </Flex>
  );
};

export default SignupPromotion;
